import { images } from "src/images";
import { IOperator, IVehicle } from "../models";
import { LiteralService, UsersService, VehiclesService } from "../services";
import { formData } from "./vehicleData";
import { InputType } from "../models/enums";
import { ConvertibleSeatsInputComponent } from "../shared/input";

export async function getVehicleForm(
  vehicle: IVehicle,
  literalsService: LiteralService,
  vehiclesService: VehiclesService,
  usersService: UsersService,
  isEdit: boolean
) {
  let operators: any[] = [];
  let selectedOperator: IOperator | undefined;
  if (isEdit) {
    operators = await getOperators(usersService);
    selectedOperator = operators.find((operator) => operator.value?.id === vehicle.operator?.id)?.value;
  }

  const data: formData[] = [
    {
      img: images.vehicles.busCar,
      title: 'vehicles.data.name',
      value: vehicle.name || '',
      required: true,
      color: true,
      edit: {
        required: true,
        inputType: InputType.TEXT,
        valueToChange: 'name',
      }
    },
    {
      img: images.vehicles.operator,
      title: 'vehicles.data.operator',
      value: isEdit ? selectedOperator : vehicle.operator?.name,
      required: true,
      color: true,
      edit: {
        id: vehicle.operator?.id,
        required: true,
        inputType: InputType.SELECT_SEARCH,
        translateValue: true,
        values: operators,
        valueToChange: 'operator',
      }
    },
    {
      img: images.vehicles.standardSeat,
      title: 'vehicles.data.standardSeatsExclusive',
      value: vehicle.availableSeats,
      required: true,
      color: true,
      edit: {
        required: true,
        inputType: InputType.NUMBER,
        valueToChange: 'availableSeats',
      }
    },
    {
      img: images.vehicles.prmSeat,
      title: 'vehicles.data.prmSeatsExclusive',
      value: vehicle.prmAvailableSeats,
      required: true,
      color: true,
      edit: {
        required: true,
        inputType: InputType.NUMBER,
        valueToChange: 'prmAvailableSeats',
      }
    },
    {
      img: images.vehicles.convertibleSeats,
      component: ConvertibleSeatsInputComponent,
      title: 'vehicles.data.convertibleSeats',
      value: vehicle.convertibleSeats,
      required: false,
      color: true,
      edit: {
        required: false,
        inputType: InputType.CONVERTIBLE_SEATS,
        valueToChange: 'convertibleSeats',
      }
    }
  ];

  return data;
}

export async function getOperators(usersService: UsersService) {
  return await usersService.getOperators().then((res) => {
    const operators: any[] = [];
    res.map((operator: IOperator) => {
      operators.push({
        id: operator.id,
        value: operator,
        label: operator.name
      });
    });
    return operators;
  });
}